import http from '../../../utils/fetch';
export default {
    selectPage(query) {
        return http({
            url: '/api/swyl/v1/hetong/BscMarketingReport/selectPage',
            method: 'post',
            params: query
        });
    },

    updateConfirmAmount(query){
        return http({
            url: '/api/swyl/v1/hetong/BscMarketingReport/updateConfirmAmount',
            method: 'post',
            params: query
        });
    },

    //手动计算地市安装数据
    saveInstallResult(query){
        return http({
            url: '/api/swyl/v1/hetong/bsCcontractXsptInstall/saveInstallResult',
            method: 'post',
            params: query
        });
    },


    //手动生成营销会议报表
    contractInstall(query){
        return http({
            url: '/api/swyl/v1/hetong/BscMarketingReport/contractInstall',
            method: 'post',
            params: query
        });
    },
    //审核
    updateApproved(query){
        return http({
            url: '/api/swyl/v1/hetong/BscMarketingReport/updateApproved',
            method: 'post',
            params: query
        });
    },
    //判断是否达标
    updateStandard(query){
        return http({
            url: '/api/swyl/v1/hetong/BscMarketingReport/updateStandard',
            method: 'post',
            params: query
        });
    },
}
